module.exports = __webpack_public_path__ + "img/cart-icon.f87430f3.svg";